"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEX_TYPES = exports.PHONE_VALIDATION_MASK = exports.PHONE_PLACEHOLDER = exports.PHONE_MASK = exports.EMPTY_PASSPORT = void 0;
var _localization = _interopRequireDefault(require("../../../../../../localization"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var PHONE_MASK = exports.PHONE_MASK = [/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/];
var PHONE_PLACEHOLDER = exports.PHONE_PLACEHOLDER = '+ХХХ (ХХ) ХХХ-ХХ-ХХ';

// eslint-disable-next-line no-useless-escape
var PHONE_VALIDATION_MASK = exports.PHONE_VALIDATION_MASK = /^[\d|\s|\+|\(|\)|\-]+$/;
var SEX_TYPES = exports.SEX_TYPES = {
  MR: {
    value: 'MR',
    get label() {
      return _localization.default.t('SEX_OPTIONS:MR');
    }
  },
  MRS: {
    value: 'MRS',
    get label() {
      return _localization.default.t('SEX_OPTIONS:MRS');
    }
  },
  CHILD: {
    value: 'CHD',
    get label() {
      return _localization.default.t('SEX_OPTIONS:CHILD');
    }
  }
};
var EMPTY_PASSPORT = exports.EMPTY_PASSPORT = {
  name: '',
  surname: '',
  passportIssued: '',
  passport: '',
  sex: SEX_TYPES.MR.value,
  birthday: '',
  citizenship: null,
  passportExpireDate: '',
  passportGivenDate: ''
};